import { useEffect } from 'react';

import type { NextPage } from 'next';
import { useTranslation } from 'react-i18next';

import { useRouter } from 'next/router';

import { Link } from '@brand/components';
import { theme } from '@brand/theme/theme';

import pages from 'constants/pages';

import { useReduxDispatch } from 'hooks/redux/useReduxDispatch';
import { useReduxSelector } from 'hooks/redux/useReduxSelector';

import LoginFormOrganism from 'components/organisms/form/auth/Login';
import BaseLayoutOrganism from 'components/organisms/layouts/Base';
import GeneralLayoutOrganism from 'components/organisms/layouts/General';

import authSelectors from 'store/slices/auth/selectors';
import { interventionActions } from 'store/slices/intervention';

const AuthPage: NextPage = () => {
  const router = useRouter();
  const { t } = useTranslation('auth');
  const accessToken = useReduxSelector(authSelectors.accessToken);
  const { i18n } = useTranslation();
  const { locale } = useReduxSelector(authSelectors.profile);

  const reduxDispatch = useReduxDispatch();

  useEffect(() => {
    if (!locale) return;
    i18n.changeLanguage(locale);
  }, [i18n, locale]);

  useEffect(() => {
    reduxDispatch(interventionActions.setClearInterventionList());
    if (accessToken) {
      router.push(pages.home);
    }
  }, [router, accessToken, reduxDispatch]);

  return (
    <BaseLayoutOrganism>
      <GeneralLayoutOrganism title={t(`login.title`)}>
        <LoginFormOrganism />
        <Link
          color={theme.colors.gray.lighter}
          display="flex"
          href={pages.forgotPassword}
          m="48px auto 0"
          type="button"
          width="fit-content"
        >
          {t('login.forgotPassword')}
        </Link>
      </GeneralLayoutOrganism>
    </BaseLayoutOrganism>
  );
};

export default AuthPage;
